import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FeatherIconsComponent } from "./components/feather-icons/feather-icons.component";
import { FooterComponent } from "./components/footer/footer.component";
import { HeaderComponent } from "./components/header/header.component";
import { SidebarComponent } from "./components/sidebar/sidebar.component";
import { ToggleFullscreenDirective } from "./directives/fullscreen.directive";
import { ContentLayoutComponent } from "./layout/content-layout/content-layout.component";
import { NavService } from "./service/nav.service";
import { WINDOW_PROVIDERS } from "./service/windows.service";
import { BreadcrumbComponent } from "./components/breadcrumb/breadcrumb.component";
import { RightSidebarComponent } from "./components/right-sidebar/right-sidebar.component";
import { TableService } from "./service/table.service";
import { NgbdSortableHeader } from "./directives/NgbdSortableHeader";
import { NgSelectModule } from "@ng-select/ng-select";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ConfirmModalComponent } from "./components/confirm-modal/confirm-modal.component";
import { ToastrModule } from "ngx-toastr";
import { PrintInputErrorComponent } from "./components/print-input-error/print-input-error.component";
import { SecondsToTimePipe } from "./pipes/secondstotime.pipe";
import { SortPipe } from "./pipes/sort.pipe";
import { SortDatePipe } from "./pipes/sortbydate";
@NgModule({
  declarations: [
    ToggleFullscreenDirective,
    FeatherIconsComponent,
    FooterComponent,
    HeaderComponent,
    SidebarComponent,
    ContentLayoutComponent,
    BreadcrumbComponent,
    RightSidebarComponent,
    NgbdSortableHeader,
    ConfirmModalComponent,
    PrintInputErrorComponent,
    SecondsToTimePipe,
    SortPipe,
    SortDatePipe
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: "toast-bottom-right",
      preventDuplicates: true,
    }),
  ],
  providers: [NavService, TableService, WINDOW_PROVIDERS],
  schemas: [NO_ERRORS_SCHEMA],
  exports: [
    FeatherIconsComponent,
    ToggleFullscreenDirective,
    NgbdSortableHeader,
    PrintInputErrorComponent,
    SecondsToTimePipe,
    SortPipe,
    SortDatePipe
  ],
})
export class SharedModule {}
